import React from 'react';
import { Menubar } from 'primereact/menubar';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { useHistory } from "react-router-dom";

const Navbar = () => {
    const history = useHistory()
    const items = [
        {
            label: 'My Profile', command:(e)=>{ history.push('/Profile');  }
        },
        {
            label: 'Batches', command:(e)=>{ history.push('/Main');  }
        },
        {
            label: 'Bills', command:(e)=>{ history.push('/Bill');  }
        },
    ];
    return (
        <Menubar tabIndex="0" style={{height:"40px", backgroundColor:"#b4ccff"}}  model={items} /> 
    );
}

export default Navbar;